import React, { FC } from 'react'
import { get } from 'lodash'
import { isNeighborhood, isPrimary, isSecondary, isShared } from '@utils'
import { IFloorMapSpace, IFloorMapEmployee, ICatalogEmployee, IUsageType } from '@api/types'
import EmployeeCatalog from '../../../../../EmployeeCatalog'
import UpdateUsageSection from '../../../../SpaceAssignmentSelect/UpdateUsageSection'
import css from './spaceAssignmentSelect.module.scss'

type AssignArgs = {
  toSpaceId: string
  fromSpaceId?: string
  employee: ICatalogEmployee
}

interface EmployeePopoverListProps {
  assignmentPlanId: string
  space?: IFloorMapSpace
  assign: (args: AssignArgs) => void
  updateSpaceUsage: (usageType: IUsageType) => void
}

const EmployeePopoverList: FC<EmployeePopoverListProps> = ({
  assignmentPlanId,
  space,
  assign,
  updateSpaceUsage,
}) => {
  if (!space) return null

  if (
    !isPrimary(space.usageType) &&
    !isSecondary(space.usageType) &&
    !isShared(space.usageType) &&
    !isNeighborhood(space.usageType)
  ) {
    return (
      <UpdateUsageSection
        text="To assign employees to this space convert it to:"
        filter={(usageType) =>
          isPrimary(usageType) || isSecondary(usageType) || isShared(usageType)
        }
        updateSpaceUsage={updateSpaceUsage}
      />
    )
  }

  const employee = get(space, 'spaceAssignment.employee')
  const sharedEmployees = get(space, 'spaceAssignment.sharedEmployees') || []

  return (
    <div className={css.employees_list}>
      <EmployeeCatalog
        assignmentPlanId={assignmentPlanId}
        multi={isShared(space.usageType) || isNeighborhood(space.usageType)}
        selection={sharedEmployees.map(({ id }: IFloorMapEmployee) => id)}
        onSelect={(empl: ICatalogEmployee) => {
          if (sharedEmployees) {
            if (
              !(get(space, 'spaceAssignment.sharedEmployees') || []).find(
                ({ id }: IFloorMapEmployee) => id === empl.id
              )
            ) {
              assign({
                employee: empl,
                toSpaceId: space.id,
                fromSpaceId: get(employee, 'spaceAssignment.space.id'),
              })
            }
          } else {
            const toSpaceId = space.id
            const fromSpaceId = get(employee, 'spaceAssignment.space.id')
            if (empl.id !== employee?.id) {
              assign({ employee: empl, toSpaceId, fromSpaceId })
            }
          }
        }}
      />
    </div>
  )
}

export default EmployeePopoverList
